<ng-template [cxOutlet]="StorefrontOutlets.STOREFRONT" cxPageTemplateStyle>
  <toasters></toasters>
  <modal-list></modal-list>
  <loader></loader>

  <ng-template cxOutlet="cx-header">
    <main-header></main-header>

    <cx-global-message aria-atomic="true" aria-live="assertive"></cx-global-message>
  </ng-template>

  <main cxSkipLink="cx-main" [cxFocus]="{ disableMouseFocus: true }">
    <!-- Do not remove this js-cx-content class, it is used to index content page -->
    <div class="js-cx-content cx-content">
      <router-outlet></router-outlet>
      <product-comparator-floating></product-comparator-floating>
    </div>

    <ng-template cxOutlet="cx-footer">
      <footer class="cx-footer" cxSkipLink="cx-footer" [cxFocus]="{ disableMouseFocus: true }">
        <cx-page-layout section="footer"></cx-page-layout>
      </footer>
    </ng-template>
  </main>
</ng-template>
